(function(){
  'use strict';

  angular.module('wml.portal.water-estafette', []);

})();
